import { Select, Space, Typography } from 'antd';
import { useOrderSearchForTicket } from 'modules/CreateTicket/store';
import { filterOption } from 'modules/utilities/utility';
import React from "react";

function CategoryFilter({ selectedCategory, setSelectedCategory }) {
  const { allCrmCategories } = useOrderSearchForTicket();

  function handleSelect(data) {
    setSelectedCategory(data);
  };
  
  return (
    <Space.Compact block className='my-2'>
      <span style={{ background: '#FAFAFA', border: '#D9D9D9', width: '30%' }} className='border border-1 border-end-0 d-flex justify-conent-center align-items-center rounded-lg rounded-start px-2'>
        <Typography.Text>Select Category</Typography.Text>
      </span>
      <Select
        mode='multiple'
        style={{ width: '70%' }}
        showSearch
        allowClear
        placeholder='Category'
        optionFilterProp='children'
        value={selectedCategory}
        onChange={handleSelect}
        filterOption={filterOption}
        options={allCrmCategories}
      />
    </Space.Compact>
  );
}

export default CategoryFilter;
